import axios from "axios";
import { Card } from "ktm-ui";
import React, { Component } from "react";
import { Table } from "react-bootstrap";
import "../styles/FlexTemplates.css";
import toastr from "toastr";
import { CustomLoading } from "components/CustomLoading";

const defaultTemplate =
'Dear *|FNAME|*\n\n' +
'*|COMPANY|* is providing you with a spending account as part of your total compensation package. ' +
'The yearly amount you have available is $*|LIMIT|*.\n\n' +

'Take a few minutes to choose how you want to use this limit by clicking the custom link below:\n\n' +
'*|LINK|*\n\n' +

'This link opens a secure browser set up by National HealthClaim, the company administering this benefit on behalf of your employer.\n\n' +

'Please make your choice by *|DEADLINE|*. If no selection is made, your company’s default of *|DEFAULT_PERCENTAGE|* will be selected for you. ' +
'Once the selection deadline has passed, changes cannot be made.\n\n' +


'*|WELCOME_MESSAGE|*\n\n' +   

'Best regards,\n' +
'National HealthClaim\n\n' +
'If you have any questions, please respond to this email and our team will be happy to assist you.';

export default class SelectionEmailTemplate extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            selectedTemplate: "Default",
            customTemplateContent: "",
            isDisabled: true,
        };

        this.edit = this.edit.bind(this);
        this.fetchCustomTemplate = this.fetchCustomTemplate.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount(): void {
        this.fetchCustomTemplate();
    }

    fetchCustomTemplate(): void {
        axios
        .get("/api/Flex/getcustomemailtemplate?policyId="+this.props.policyId)
        .then((response) => {
            this.setState({
                loading: false,
                selectedTemplate: response.data.customEmailTemplate ? "Custom" : "Default",
                customTemplateContent: response.data.customEmailTemplate || "",
            });
        })
        .catch((error) => {
            toastr.error("Error while fetching template","Error");
        });
    }

    edit(): void {
        this.setState({ isDisabled: false });
    }

    handleSave(): void {
        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note:  "Selection Email Template: " + this.state.selectedTemplate,
            Action: "Policy Edit Flex Template Settings",
            PolicyId: this.props.policyId,
            }),
        };
        this.setState({ isDisabled: true });
        axios
        .put("/api/Flex/updatecustomemailtemplate", {
            policyId: this.props.policyId,
            customTemplateContent: this.state.customTemplateContent,
            templateType: this.state.selectedTemplate
        })
        .then((response) => {
            if (response.data.success) {
                this.fetchCustomTemplate();
                toastr.success("Template saved successfully","Success");
            }
            else
            {
                toastr.error("Error while saving template","Error");
            }
        })
        .then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        })
        .catch((error) => {
            toastr.error("Error while saving template","Error");
        });
    }

    handleCancel(): void {
        this.setState({ 
            selectedTemplate: "Default",
            isDisabled: true 
        });
    }

    toggleTemplateOption(e) {
        this.setState({ selectedTemplate: e.target.value });
    }

    render() {
        var content = null;
        if (this.state.loading) {
            content = (<CustomLoading />);
        } else {
            content = (
                <Card 
                    label="Selection Email Template"
                    actions={<><a href="#" className="RT-Link" onClick={this.edit}>Edit</a></>}
                >
                    <div className="selection-options">
                        <label>
                            <input
                            className="default-checkbox"
                            type="checkbox"
                            value={"Default"}
                            checked={this.state.selectedTemplate == "Default"}
                            onChange={(e) => this.toggleTemplateOption(e)}
                            disabled={this.state.isDisabled}
                            />
                            Default
                        </label>
                        <label>
                            <input
                            className="custom-checkbox"
                            type="checkbox"
                            value={"Custom"}
                            checked={this.state.selectedTemplate == "Custom"}
                            onChange={(e) => this.toggleTemplateOption(e)}
                            disabled={this.state.isDisabled}
                            />
                            Custom
                        </label>
                    </div>
                    <div className="merge-tags">
                        <label>Merge Tags</label>
                        <Table className="merge-tags-table">
                            <thead>
                                <tr>
                                    <th>TAG</th>
                                    <th>DESCRIPTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{`*|FNAME|*`}</td>
                                    <td>Employee's first name</td>
                                </tr>
                                <tr>
                                    <td>{`*|LNAME|*`}</td>
                                    <td>Employee's last name</td>
                                </tr>
                                <tr>
                                    <td>{`*|LIMIT|*`}</td>
                                    <td>Total assigned limit</td>
                                </tr>
                                <tr>
                                    <td>{`*|DEADLINE|*`}</td>
                                    <td>Selection deadline</td>
                                </tr>
                                <tr>
                                    <td>{`*|LINK|*`}</td>
                                    <td>Selection link</td>
                                </tr>
                                <tr>
                                    <td>{`*|PAFIRST|*`}</td>
                                    <td>Plan admin first name</td>
                                </tr>
                                <tr>
                                    <td>{`*|PALAST|*`}</td>
                                    <td>Plan admin last name</td>
                                </tr>
                                <tr>
                                    <td>{`*|COMPANY|*`}</td>
                                    <td>Company name</td>
                                </tr>
                                <tr>
                                    <td>{`*|DEFAULT_PERCENTAGE|*`}</td>
                                    <td>Default percentage “50% HSA and 50% LSA” for example</td>
                                </tr>
                                 <tr>
                                    <td>{`*|WELCOME_MESSAGE|*`}</td>
                                    <td>Welcome message</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                    <div className="selection-email-template-content">
                        <label>{this.state.selectedTemplate+" Template"}</label>
                        <textarea 
                            className="email-template-textarea"
                            value={this.state.selectedTemplate == "Default" ? defaultTemplate : this.state.customTemplateContent}
                            disabled={this.state.isDisabled}
                            onChange={(e) => this.setState({ customTemplateContent: e.target.value })}
                        >
                        </textarea>
                    </div>
                    <div className="flex-templates-buttons">
                        <button className="RT-Button" disabled={this.state.isDisabled} onClick={this.handleCancel}>Cancel</button>
                        <button className="RT-Button RT-Button--primary RT-Button--large RT-Button--large" disabled={this.state.isDisabled} onClick={this.handleSave}>Save</button>
                    </div>
                </Card>
            );
        }

        return (<div className="selection-email-template-container" style={{marginBottom:20}}>{content}</div>);
    }
}